<template>
  <section class="min-h-screen flex items-center lg:min-h-screen md:min-h-auto">
    <div class="w-full flex lg:flex-row flex-col">
      <div class="flex w-full lg:flex-row flex-col">
        <!-- 左侧：#399368背景区域 - PC端40%宽度，移动端全宽 -->
        <div
          class="bg-[#399368] text-white flex flex-col justify-center lg:min-h-screen md:min-h-[40vh] min-h-[35vh] relative overflow-hidden lg:w-[40%] w-full"
        >
          <!-- 面包袋图片 - PC端左下角定位，移动端隐藏 -->
          <div class="hidden lg:block lg:absolute lg:left-0 lg:bottom-0">
            <img
              :src="getImagePath(1)"
              alt="Bread bag"
              class="w-100 h-100 object-cover"
            />
          </div>

          <!-- 标题和描述 - PC端右上角，移动端居中 -->
          <div class="lg:absolute lg:top-50 lg:right-20 lg:space-y-6 lg:max-w-xs space-y-4 md:space-y-6 px-6 md:px-8 lg:px-0 text-center lg:text-left">
            <div>
              <h2
                class="lg:text-4xl xl:text-5xl text-2xl md:text-3xl font-bold leading-tight mb-2 italic drop-shadow-lg"
              >
                {{ t('chooseUs.title') }}
              </h2>
              <h3 class="lg:text-xl xl:text-2xl text-lg md:text-xl font-light opacity-90 italic drop-shadow-md">
                {{ t('chooseUs.subtitle') }}
              </h3>
            </div>
            <p class="lg:text-sm text-sm md:text-base leading-relaxed opacity-90 max-w-md lg:max-w-xs mx-auto lg:mx-0 drop-shadow-sm">
              {{ t('chooseUs.description') }}
            </p>
          </div>

          <!-- PC端装饰性渐变遮罩 -->
          <div class="hidden lg:block absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-black/5 pointer-events-none"></div>
        </div>

        <!-- 右侧：米色背景区域 - PC端60%宽度，移动端全宽 -->
        <div
          class="flex items-center justify-center lg:min-h-screen min-h-auto lg:px-8 px-4 md:px-6 py-8 lg:py-0 lg:w-[60%] w-full"
          style="background-color: #f8f4e9"
        >
          <!-- 四个优势卡片 -->
          <div class="lg:grid lg:grid-cols-2 flex flex-col lg:gap-6 gap-4 md:gap-6 w-full lg:max-w-2xl max-w-lg">
            <!-- 质量卡片 -->
            <div
              class="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all duration-300 lg:transform lg:hover:scale-105 lg:hover:-translate-y-1"
            >
              <div class="lg:h-48 h-40 md:h-44 flex items-center justify-center p-3 lg:p-4">
                <img
                  :src="getImagePath(2)"
                  :alt="t('chooseUs.advantages[0].title')"
                  class="w-full h-full object-cover rounded"
                />
              </div>
              <div class="p-3 lg:p-4">
                <h4 class="lg:text-lg text-base md:text-lg font-bold text-[#2f5c45] mb-2">
                  {{ t('chooseUs.advantages[0].title') }}
                </h4>
                <p class="text-gray-600 lg:text-xs text-sm leading-relaxed">
                  {{ t('chooseUs.advantages[0].description') }}
                </p>
              </div>
            </div>

            <!-- 服务卡片 -->
            <div
              class="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all duration-300 lg:transform lg:hover:scale-105 lg:hover:-translate-y-1"
            >
              <div class="lg:h-48 h-40 md:h-44 flex items-center justify-center p-3 lg:p-4">
                <img
                  :src="getImagePath(3)"
                  :alt="t('chooseUs.advantages[1].title')"
                  class="w-full h-full object-cover rounded"
                />
              </div>
              <div class="p-3 lg:p-4">
                <h4 class="lg:text-lg text-base md:text-lg font-bold text-[#2f5c45] mb-2">
                  {{ t('chooseUs.advantages[1].title') }}
                </h4>
                <p class="text-gray-600 lg:text-xs text-sm leading-relaxed">
                  {{ t('chooseUs.advantages[1].description') }}
                </p>
              </div>
            </div>

            <!-- 生产卡片 -->
            <div
              class="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all duration-300 lg:transform lg:hover:scale-105 lg:hover:-translate-y-1"
            >
              <div class="lg:h-48 h-40 md:h-44 flex items-center justify-center p-3 lg:p-4">
                <img
                  :src="getImagePath(4)"
                  :alt="t('chooseUs.advantages[2].title')"
                  class="w-full h-full object-cover rounded"
                />
              </div>
              <div class="p-3 lg:p-4">
                <h4 class="lg:text-lg text-base md:text-lg font-bold text-[#2f5c45] mb-2">
                  {{ t('chooseUs.advantages[2].title') }}
                </h4>
                <p class="text-gray-600 lg:text-xs text-sm leading-relaxed">
                  {{ t('chooseUs.advantages[2].description') }}
                </p>
              </div>
            </div>

            <!-- 承诺卡片 -->
            <div
              class="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all duration-300 lg:transform lg:hover:scale-105 lg:hover:-translate-y-1"
            >
              <div class="lg:h-48 h-40 md:h-44 flex items-center justify-center p-3 lg:p-4">
                <img
                  :src="getImagePath(5)"
                  :alt="t('chooseUs.advantages[3].title')"
                  class="w-full h-full object-cover rounded"
                />
              </div>
              <div class="p-3 lg:p-4">
                <h4 class="lg:text-lg text-base md:text-lg font-bold text-[#2f5c45] mb-2">
                  {{ t('chooseUs.advantages[3].title') }}
                </h4>
                <p class="text-gray-600 lg:text-xs text-sm leading-relaxed">
                  {{ t('chooseUs.advantages[3].description') }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
  import { useI18n } from 'vue-i18n'
  import { computed } from 'vue'

  // 使用组合式API进行国际化
  const { t, locale, messages } = useI18n()

  // 动态获取图片路径的函数
  const getImagePath = imageNumber => {
    try {
      // 使用动态导入来获取图片
      return new URL(`../../../assets/5699/${imageNumber}.png`, import.meta.url)
        .href
    } catch (error) {
      console.warn(`Image not found: 5699/${imageNumber}.png`)
      // 返回默认图片或占位符
      return new URL('../../../assets/5699/1.png', import.meta.url).href
    }
  }
</script>

<style scoped>
  /* PC端增强的卡片悬停效果 */
  @media (min-width: 1025px) {
    .bg-white:hover {
      transform: translateY(-4px) scale(1.05);
      box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.2);
    }
  }

  /* 移动端优化的悬停效果 */
  @media (max-width: 1024px) {
    .bg-white:hover {
      transform: translateY(-2px);
      box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.15);
    }
    
    /* 移动端触摸优化 */
    .bg-white:active {
      transform: scale(0.98);
    }
  }

  /* 平板端适配 */
  @media (min-width: 769px) and (max-width: 1024px) {
    .lg\:grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    }
    
    .flex-col {
      flex-direction: row;
    }
  }

  /* 移动端专用样式 */
  @media (max-width: 768px) {
    /* 确保移动端垂直布局 */
    .lg\:flex-row {
      flex-direction: column;
    }
    
    /* 移动端卡片间距优化 */
    .lg\:gap-6 {
      gap: 1rem;
    }
    
    /* 移动端文字阴影增强可读性 */
    .text-white {
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    }
  }

  /* 小屏幕移动端优化 */
  @media (max-width: 480px) {
    .lg\:gap-6 {
      gap: 0.75rem;
    }
    
    .p-3 {
      padding: 0.75rem;
    }
  }

  /* 文字阴影效果 */
  .drop-shadow-lg {
    filter: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
  }

  .drop-shadow-md {
    filter: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  }

  .drop-shadow-sm {
    filter: drop-shadow(0 1px 1px rgb(0 0 0 / 0.05));
  }
</style>
